import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-28 overflow-hidden bg-[#0a0a0a]">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0f23a19aec2569c8c349573bdf15674f.jpg"
          alt="Appalachia"
          className="w-full h-full object-cover object-top opacity-25"
        />
        <div className="absolute inset-0 bg-[#0a0a0a]/60" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
        <div className="inline-block border border-[#D4AF37]/40 px-4 py-1.5 mb-6">
          <span className="text-[#D4AF37] text-xs font-bold uppercase tracking-[0.3em] font-sans">Independent Agency — We Work For You</span>
        </div>
        <h2 className="font-serif text-4xl md:text-6xl text-white uppercase mb-6 leading-tight">
          Call Today for a Quote
        </h2>
        <p className="text-white/50 text-lg mb-10 font-sans leading-relaxed max-w-2xl mx-auto">
          Our mission is simple: provide reliable coverage, honest guidance, and fast service — so you can grow your business with confidence.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="tel:6062691190"
            className="px-8 py-4 bg-[#D4AF37] text-black font-bold text-sm uppercase tracking-widest rounded-md hover:bg-[#e8c84e] transition-colors whitespace-nowrap cursor-pointer font-sans">
            Call 606-269-1190
          </a>
          <Link to="/contact"
            className="px-8 py-4 border border-white/20 text-white font-bold text-sm uppercase tracking-widest rounded-md hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors whitespace-nowrap cursor-pointer font-sans">
            Send a Message
          </Link>
        </div>
      </div>
    </section>
  );
}
